module.exports = __webpack_public_path__ + "img/13.04f2465c.png";